/**
 * What the console's screens need in a region, by project role — least privilege instead of every
 * scope the role holds. Reads for everyone; writes (unmerge, cohorts) and customer SQL from member
 * up; unmasked personal data (persons.pii) only for admins and owners. Must stay a subset of the
 * role's scopes (crates/auth scopes.rs role_scopes), or the control plane answers 403.
 */
export function consoleRegionScopes(role: string): string[] {
  const read = ["query:read", "persons:read", "cohorts:read", "catalog:read"];
  if (role === "viewer") return read;
  const member = [...read, "persons:write", "cohorts:write", "sql.raw"];
  return role === "admin" || role === "owner" ? [...member, "persons.pii"] : member;
}
